import { useState } from "react";
import Button from "../Button/Button";

interface ITileProps {
  src: string;
  name: string;
  date: string;
  className?: string;
  onClick: () => void;
}
export const MembershipTile: React.FC<ITileProps> = ({
  src = "",
  name = "",
  date = "",
  className = "",
  onClick,
}) => {
  const [isHover, setHover] = useState(false);

  const handleHover = (value: boolean) => {
    setHover(value);
  };

  return (
    <div
      className={`membership-tile-container ${className}`}
      onMouseOver={() => handleHover(true)}
      onMouseOut={() => handleHover(false)}
    >
      <img
        src={src}
        alt={name}
        className={`ps-0 image-style ${isHover && "img-hover"}`}
      />
      {!isHover && <div className="bottom-shadow"></div>}
      <div className={`overlay-text ${isHover && "overlay-text-hover"}`}>
        <div className={"font-500-30 line-35 bottom-20"}>{name}</div>
        <div className="">
          <div className="mt-3 mb-1 font-300 font-16">Expires: {date}</div>
          <Button
            label={
              <span className="font-500-14">
                <>Go to Listing</>
                <i className="fa-solid fa-arrow-right ms-2 my-auto"></i>
              </span>
            }
            onClick={onClick}
            className="mt-1 py-0 button-bg-transparent"
          />
        </div>
      </div>
    </div>
  );
};
